import { useState, useRef } from 'react';

import './App.scss';
import projectImage from './Healthy.png';
import projectImage1 from './project1.png';
import projectImage2 from './2048.png';
import projectImage3 from './project3.png';
function App() {
	const aboutRef = useRef(null);
	const projectsRef = useRef(null);
	const homeRef = useRef(null);

	const scrollToAbout = () => {
		if (aboutRef.current) {
			aboutRef.current.scrollIntoView({ behavior: 'smooth' });
		}
	};

	const scrollToProjects = () => {
		if (projectsRef.current) {
			projectsRef.current.scrollIntoView({ behavior: 'smooth' });
		}
	};

	const scrollToHome = () => {
		if (homeRef.current) {
			homeRef.current.scrollIntoView({ behavior: 'smooth' });
		}
	};

	return (
		<>
			<Navbar
				scrollToAbout={scrollToAbout}
				scrollToProjects={scrollToProjects}
				scrollToHome={scrollToHome}
			/>
			<div className='sidebar--left side-bars'>
				<a
					href='https://github.com/SebastianPrzyimka'
					target='_blank'
					rel='noreferrer'
				>
					<svg
						xmlns='http://www.w3.org/2000/svg'
						width='22'
						height='23'
						id='github'
						className='fill'
						viewBox='0 0 22 23'
					>
						<path
							fill='none'
							stroke='#fff'
							stroke-linecap='round'
							stroke-linejoin='round'
							stroke-width='2'
							d='M8 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 19 4.77 5.07 5.07 0 0 0 18.91 1S17.73.65 15 2.48a13.38 13.38 0 0 0-7 0C5.27.65 4.09 1 4.09 1A5.07 5.07 0 0 0 4 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 8 18.13V22'
						></path>
					</svg>
				</a>
			</div>
			<div className='sidebar--right side-bars side-bars-name'>
				<a href='mailto:seba.przyimka@gmail.com'>seba.przyimka@gmail.com</a>
			</div>
			<div className='container'>
				<div className='test'>
					<Intro homeRef={homeRef} />
				</div>
				<About aboutRef={aboutRef} />
				<ProjectsOne projectsRef={projectsRef} />
				<ProjectsTwo />
				<ProjectsThree />
				<ProjectsFour />
			</div>
		</>
	);
}

function Navbar({ scrollToAbout, scrollToProjects, scrollToHome }) {
	const [toggle, setToggle] = useState(false);

	const handleToggle = function () {
		setToggle(!toggle);
	};

	return (
		<nav className={`navbar`}>
			<button href='#' className='toggle--button' onClick={handleToggle}>
				<span className='toggle--button-bar'></span>
				<span className='toggle--button-bar'></span>
				<span className='toggle--button-bar'></span>
			</button>
			<div className={`navbar__links ${toggle ? 'active' : ''}`}>
				<ul>
					<li>
						<a href='#home' onClick={scrollToHome}>
							<span className='underline'>00. </span>Home
						</a>
					</li>
					<li>
						<a href='#about' onClick={scrollToAbout}>
							<span className='underline'>01. </span>About
						</a>
					</li>
					<li>
						<a href='#projects' onClick={scrollToProjects}>
							<span className='underline'>02. </span>Projects
						</a>
					</li>
					<li>
						<a href='mailto:seba.przyimka@gmail.com'>
							<span className='underline'>03. </span>Contact
						</a>
					</li>
					<li>
						<a
							href='https://emerald-lurette-90.tiiny.site'
							className='navbar__resume'
							target='_blank'
							rel='noreferrer'
						>
							Resume
						</a>
					</li>
				</ul>
			</div>
		</nav>
	);
}

function Intro({ homeRef }) {
	const [visited, setVisited] = useState(false);

	const clicked = function () {
		setVisited(true);
	};

	return (
		<header className='header' ref={homeRef}>
			<span className='header__title'>Hi, my name is</span>
			<h1 className='header--name'>
				<span className='header--name-1'>Sebastian Przyimka.</span>
				<span className='header--name-2'>Front End Developer.</span>
			</h1>
			<p className='header__description'>
				I am a front-end software engineer focused on crafting accessible and
				performant experiences on the web. With a keen eye for detail and a
				passion for learning, I am always searching for ways to improve the
				quality of the web for everyone. I specialize in{' '}
				<span className='underline'>React.js</span>{' '}
				{/* <span className='underline'>Next.js </span> */}
				and Currently I am focused on finding opportunities to gain professional
				experience.
			</p>
			<a
				href='https://github.com/SebastianPrzyimka'
				target='_blank'
				rel='noreferrer'
				className={`header__git ${visited ? 'clicked' : ''}`}
				onClick={clicked}
			>
				Check My Github
			</a>
		</header>
	);
}

function About({ aboutRef }) {
	return (
		<div className='about' ref={aboutRef}>
			<h1 className='about__title'>
				<span className='color-span'>01.</span> About Me
			</h1>
			<div className='about__me'>
				<div className='about__me--intro'>
					<p className='y-3'>
						Hello! My name is Sebastian and I'm from Glasgow. I really enjoy
						creating web and mobile apps and learning new technologies.
					</p>
					<p className='y-3'>
						I'm a disciplined, ambitious and creative software engineer with
						{/*various*/} various skills. I specialize in React{' '}
						{/*and Next.js*/} but in the near future i want to become Full Stack
						Developer and start connecting the dots on the Back-end with
						Express.
					</p>
					<p className='y-3'>
						Here are a few technologies I've been working with recently:
					</p>
					<div className='about__me--skills'>
						<ul className='x-3 column--1'>
							<li>JavaScript</li>
							<li>Typescript</li>
							<li>React.js 18+</li>
							<li>Next.js</li>
							{/* <li>Node.js / Express.js}</li> */}
							{/*<li>MongoDB</li>*/}
						</ul>
						<ul>
							<li>CSS / SASS / TailwindCSS / Styled Components</li>
							<li>Redux/Context Api</li>
							<li>React Router</li>
							<li>Supabase</li>
							{/*<li>React Native</li>*/}
							{/*<li>Next.js 14+</li>*/}
						</ul>
					</div>
				</div>
			</div>
		</div>
	);
}

function ProjectsOne({ projectsRef }) {
	return (
		<div className='projects'>
			<div className='projects__title'>
				<h2>
					<span className='color-span' ref={projectsRef}>
						02.
					</span>{' '}
					Projects
				</h2>
			</div>
			<div className='projects__img'>
				<img className='projects__img--pic' src={projectImage} alt='project1' />

				<div className='projects--used'>
					{/* <h3 className='projects__title--name projects__title--name-ones'>
						Healthy Foodie
					</h3> */}

					{/* <div className='projects__title--used projects__title--used-one projects__title--used-ones one'>
						<ul>
							<li>React</li>
							<li>Redux/React Router</li>
							<li>Tailwind</li>
							<li>Node.Js/Express</li>
						</ul>
					</div> */}
				</div>
				<div className='projects--description projects--description-ones description-one des-one'>
					<p>
						<span>Healthy Foodie </span>
						<strong className='underline'>
							- App may take 10–20 seconds to load initially due to free-tier
							server cold starts.
						</strong>
					</p>
					<p>
						Full-stack food ordering app built with React, Redux, Tailwind, and
						React Router. Node.js/Express backend (with help from Claude AI)
						handles orders, Stripe payments, and menu data. Deployed on Render.
					</p>
					<ul className='ul'>
						<li>React</li>
						<li>Redux/React Router</li>
						<li>Tailwind</li>
						<li>Node.Js/Express</li>
					</ul>
					<a
						href='https://healthyfoodies.onrender.com'
						target='_blank'
						rel='noreferrer'
					>
						<svg
							className='link'
							xmlns='http://www.w3.org/2000/svg'
							shape-rendering='geometricPrecision'
							text-rendering='geometricPrecision'
							image-rendering='optimizeQuality'
							fill-rule='evenodd'
							clip-rule='evenodd'
							viewBox='0 0 509 511.54'
						>
							<path
								fill-rule='nonzero'
								d='M447.19 347.03c0-17.06 13.85-30.91 30.91-30.91 17.05 0 30.9 13.85 30.9 30.91v87.82c0 21.08-8.63 40.29-22.51 54.18-13.88 13.88-33.09 22.51-54.18 22.51H76.69c-21.09 0-40.3-8.63-54.18-22.51C8.63 475.14 0 455.93 0 434.85V76.69c0-21.09 8.63-40.3 22.51-54.18C36.39 8.63 55.6 0 76.69 0h86.98c17.06 0 30.9 13.85 30.9 30.9 0 17.06-13.84 30.91-30.9 30.91H76.69c-4.07 0-7.82 1.69-10.51 4.37-2.68 2.69-4.37 6.44-4.37 10.51v358.16c0 4.06 1.69 7.82 4.37 10.5 2.69 2.68 6.44 4.38 10.51 4.38h355.62c4.07 0 7.82-1.7 10.51-4.38 2.68-2.68 4.37-6.44 4.37-10.5v-87.82zm0-243.56L308.15 244.28c-11.91 12.12-31.45 12.28-43.56.37-12.11-11.91-12.28-31.45-.37-43.56L401.77 61.81H309.7c-17.06 0-30.9-13.85-30.9-30.91 0-17.05 13.84-30.9 30.9-30.9h168.4C495.15 0 509 13.85 509 30.9v165.04c0 17.06-13.85 30.9-30.9 30.9-17.06 0-30.91-13.84-30.91-30.9v-92.47z'
							/>
						</svg>
					</a>
					<a
						href='https://github.com/SebastianPrzyimka/Healthy-app'
						target='_blank'
						rel='noreferrer'
					>
						<svg
							xmlns='http://www.w3.org/2000/svg'
							width='5'
							height='32'
							className='link githubs-1 '
							id='github'
							viewBox='0 0 22 23'
						>
							<path
								fill='none'
								stroke='#fff'
								stroke-linecap='round'
								stroke-linejoin='round'
								stroke-width='2.4'
								d='M8 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 19 4.77 5.07 5.07 0 0 0 18.91 1S17.73.65 15 2.48a13.38 13.38 0 0 0-7 0C5.27.65 4.09 1 4.09 1A5.07 5.07 0 0 0 4 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 8 18.13V22'
							></path>
						</svg>
					</a>
				</div>
			</div>
		</div>
	);
}

function ProjectsTwo() {
	return (
		<div className='projects'>
			<div className='projects__img'>
				<div className='projects--used'>
					{/* <h3 className='projects__title--name projects__title--name projects__title--name-one'>
						2048
					</h3> */}
					{/* <div className='projects__title--used projects__title--used-one projects__title--used-one-right'>
						<ul>
							<li>ES6+ JavaScript</li>
							<li>SASS</li>
							<li>HTML</li>
						</ul>
					</div> */}
				</div>
				<div className='projects--description--right projects--description-one '>
					<p>
						2048 - great game made in Vanilla Javascript ES6+ and SASS
						preprocessor.
					</p>
					<ul className='ul'>
						<li>ES6+ JavaScript</li>
						<li>SASS</li>
						<li>HTML</li>
					</ul>

					<a
						href='https://seba2048.netlify.app/'
						target='_blank'
						rel='noreferrer'
					>
						<svg
							className='link'
							xmlns='http://www.w3.org/2000/svg'
							shape-rendering='geometricPrecision'
							text-rendering='geometricPrecision'
							image-rendering='optimizeQuality'
							fill-rule='evenodd'
							clip-rule='evenodd'
							viewBox='0 0 509 511.54'
						>
							<path
								fill-rule='nonzero'
								d='M447.19 347.03c0-17.06 13.85-30.91 30.91-30.91 17.05 0 30.9 13.85 30.9 30.91v87.82c0 21.08-8.63 40.29-22.51 54.18-13.88 13.88-33.09 22.51-54.18 22.51H76.69c-21.09 0-40.3-8.63-54.18-22.51C8.63 475.14 0 455.93 0 434.85V76.69c0-21.09 8.63-40.3 22.51-54.18C36.39 8.63 55.6 0 76.69 0h86.98c17.06 0 30.9 13.85 30.9 30.9 0 17.06-13.84 30.91-30.9 30.91H76.69c-4.07 0-7.82 1.69-10.51 4.37-2.68 2.69-4.37 6.44-4.37 10.51v358.16c0 4.06 1.69 7.82 4.37 10.5 2.69 2.68 6.44 4.38 10.51 4.38h355.62c4.07 0 7.82-1.7 10.51-4.38 2.68-2.68 4.37-6.44 4.37-10.5v-87.82zm0-243.56L308.15 244.28c-11.91 12.12-31.45 12.28-43.56.37-12.11-11.91-12.28-31.45-.37-43.56L401.77 61.81H309.7c-17.06 0-30.9-13.85-30.9-30.91 0-17.05 13.84-30.9 30.9-30.9h168.4C495.15 0 509 13.85 509 30.9v165.04c0 17.06-13.85 30.9-30.9 30.9-17.06 0-30.91-13.84-30.91-30.9v-92.47z'
							/>
						</svg>
					</a>
					<a
						href='https://github.com/SebastianPrzyimka/2048'
						target='_blank'
						rel='noreferrer'
					>
						<svg
							xmlns='http://www.w3.org/2000/svg'
							width='5'
							height='33'
							id='github'
							className='link githubs'
							viewBox='0 0 22 23'
						>
							<path
								fill='none'
								stroke='#fff'
								stroke-linecap='round'
								stroke-linejoin='round'
								stroke-width='2.4'
								d='M8 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 19 4.77 5.07 5.07 0 0 0 18.91 1S17.73.65 15 2.48a13.38 13.38 0 0 0-7 0C5.27.65 4.09 1 4.09 1A5.07 5.07 0 0 0 4 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 8 18.13V22'
							></path>
						</svg>
					</a>
				</div>
				<img
					className='projects__img--pic'
					src={projectImage2}
					alt='project1'
				/>
			</div>
		</div>
	);
}

function ProjectsThree() {
	return (
		<div className='projects'>
			<div className='projects__img'>
				<img
					className='projects__img--pic'
					src={projectImage1}
					alt='project1'
				/>

				<div className='projects--used'>
					<div>
						{/* <h3 className='projects__title--name projects__title--name-one projects__title--name-one-left '>
							Creative Tim
						</h3> */}
					</div>
					{/* <div className='projects__title--used projects__title--used-one projects__title--used-one-left'>
						<ul>
							<li>JavaScript</li>
							<li>HTML</li>
							<li>SASS</li>
						</ul>
					</div> */}
				</div>
				<div className='projects--description--left projects--description-one projects--description-one-left'>
					<p>
						Creative Tim - a beautiful website created around an UX/UI book that
						I tried to rewrite nearly pixel-perfect. There is some cool JS
						functionality added as well.
					</p>
					<ul className='ul'>
						<li>JavaScript</li>
						<li>HTML</li>
						<li>SASS</li>
					</ul>
					<a
						href='https://creativeseb.netlify.app/'
						target='_blank'
						rel='noreferrer'
					>
						<svg
							className='link'
							xmlns='http://www.w3.org/2000/svg'
							shape-rendering='geometricPrecision'
							text-rendering='geometricPrecision'
							image-rendering='optimizeQuality'
							fill-rule='evenodd'
							clip-rule='evenodd'
							viewBox='0 0 509 511.54'
						>
							<path
								fill-rule='nonzero'
								d='M447.19 347.03c0-17.06 13.85-30.91 30.91-30.91 17.05 0 30.9 13.85 30.9 30.91v87.82c0 21.08-8.63 40.29-22.51 54.18-13.88 13.88-33.09 22.51-54.18 22.51H76.69c-21.09 0-40.3-8.63-54.18-22.51C8.63 475.14 0 455.93 0 434.85V76.69c0-21.09 8.63-40.3 22.51-54.18C36.39 8.63 55.6 0 76.69 0h86.98c17.06 0 30.9 13.85 30.9 30.9 0 17.06-13.84 30.91-30.9 30.91H76.69c-4.07 0-7.82 1.69-10.51 4.37-2.68 2.69-4.37 6.44-4.37 10.51v358.16c0 4.06 1.69 7.82 4.37 10.5 2.69 2.68 6.44 4.38 10.51 4.38h355.62c4.07 0 7.82-1.7 10.51-4.38 2.68-2.68 4.37-6.44 4.37-10.5v-87.82zm0-243.56L308.15 244.28c-11.91 12.12-31.45 12.28-43.56.37-12.11-11.91-12.28-31.45-.37-43.56L401.77 61.81H309.7c-17.06 0-30.9-13.85-30.9-30.91 0-17.05 13.84-30.9 30.9-30.9h168.4C495.15 0 509 13.85 509 30.9v165.04c0 17.06-13.85 30.9-30.9 30.9-17.06 0-30.91-13.84-30.91-30.9v-92.47z'
							/>
						</svg>
					</a>
				</div>
			</div>
		</div>
	);
}

function ProjectsFour() {
	return (
		<div className='projects'>
			<div className='projects__img'>
				<div className='projects--used'>
					{/* <h3 className='projects__title--name projects__title--name projects__title--name-one'>
						Divingspot
					</h3> */}
					<div className='projects__title--used projects__title--used-one projects__title--used-one-right'>
						{/* <ul>
							<li>JavaScript</li>
							<li>CSS</li>
							<li>HTML</li>
						</ul> */}
					</div>
				</div>
				<div className='projects--description--right projects--description-one '>
					<p>
						Divingspot - My first ever website created, this project showcase my
						passion for diving.
					</p>
					<ul className='ul'>
						<li>JavaScript</li>
						<li>CSS</li>
						<li>HTML</li>
					</ul>
					<a
						href='https://divingseb.netlify.app/'
						target='_blank'
						rel='noreferrer'
					>
						<svg
							className='link'
							xmlns='http://www.w3.org/2000/svg'
							shape-rendering='geometricPrecision'
							text-rendering='geometricPrecision'
							image-rendering='optimizeQuality'
							fill-rule='evenodd'
							clip-rule='evenodd'
							viewBox='0 0 509 511.54'
						>
							<path
								fill-rule='nonzero'
								d='M447.19 347.03c0-17.06 13.85-30.91 30.91-30.91 17.05 0 30.9 13.85 30.9 30.91v87.82c0 21.08-8.63 40.29-22.51 54.18-13.88 13.88-33.09 22.51-54.18 22.51H76.69c-21.09 0-40.3-8.63-54.18-22.51C8.63 475.14 0 455.93 0 434.85V76.69c0-21.09 8.63-40.3 22.51-54.18C36.39 8.63 55.6 0 76.69 0h86.98c17.06 0 30.9 13.85 30.9 30.9 0 17.06-13.84 30.91-30.9 30.91H76.69c-4.07 0-7.82 1.69-10.51 4.37-2.68 2.69-4.37 6.44-4.37 10.51v358.16c0 4.06 1.69 7.82 4.37 10.5 2.69 2.68 6.44 4.38 10.51 4.38h355.62c4.07 0 7.82-1.7 10.51-4.38 2.68-2.68 4.37-6.44 4.37-10.5v-87.82zm0-243.56L308.15 244.28c-11.91 12.12-31.45 12.28-43.56.37-12.11-11.91-12.28-31.45-.37-43.56L401.77 61.81H309.7c-17.06 0-30.9-13.85-30.9-30.91 0-17.05 13.84-30.9 30.9-30.9h168.4C495.15 0 509 13.85 509 30.9v165.04c0 17.06-13.85 30.9-30.9 30.9-17.06 0-30.91-13.84-30.91-30.9v-92.47z'
							/>
						</svg>
					</a>
				</div>
				<img
					className='projects__img--pic'
					src={projectImage3}
					alt='project3'
				/>
			</div>
		</div>
	);
}

// function ProjectsTwo() {
// 	return (
// 		<div className='projects'>
// 			<div className='projects__img'>
// 				<div className='projects--used'>
// 					<h3 className='projects__title--name projects__title--name projects__title--name-one'>
// 						Creative Tim
// 					</h3>
// 					<div className='projects__title--used projects__title--used-one projects__title--used-one-right'>
// 						<ul>
// 							<li>ES6+ JavaScript</li>
// 							<li>SASS</li>
// 							<li>HTML</li>
// 						</ul>
// 					</div>
// 				</div>
// 				<div className='projects--description--right projects--description-one '>
// 					<p>
// 						Creative Tim - a beautiful website created around an UX/UI book that
// 						I tried to rewrite nearly pixel-perfect. There is some cool JS
// 						functionality added as well.
// 					</p>
// 					<a
// 						href='https://creativeseb.netlify.app/'
// 						target='_blank'
// 						rel='noreferrer'
// 					>
// 						<svg
// 							className='link'
// 							xmlns='http://www.w3.org/2000/svg'
// 							shape-rendering='geometricPrecision'
// 							text-rendering='geometricPrecision'
// 							image-rendering='optimizeQuality'
// 							fill-rule='evenodd'
// 							clip-rule='evenodd'
// 							viewBox='0 0 509 511.54'
// 						>
// 							<path
// 								fill-rule='nonzero'
// 								d='M447.19 347.03c0-17.06 13.85-30.91 30.91-30.91 17.05 0 30.9 13.85 30.9 30.91v87.82c0 21.08-8.63 40.29-22.51 54.18-13.88 13.88-33.09 22.51-54.18 22.51H76.69c-21.09 0-40.3-8.63-54.18-22.51C8.63 475.14 0 455.93 0 434.85V76.69c0-21.09 8.63-40.3 22.51-54.18C36.39 8.63 55.6 0 76.69 0h86.98c17.06 0 30.9 13.85 30.9 30.9 0 17.06-13.84 30.91-30.9 30.91H76.69c-4.07 0-7.82 1.69-10.51 4.37-2.68 2.69-4.37 6.44-4.37 10.51v358.16c0 4.06 1.69 7.82 4.37 10.5 2.69 2.68 6.44 4.38 10.51 4.38h355.62c4.07 0 7.82-1.7 10.51-4.38 2.68-2.68 4.37-6.44 4.37-10.5v-87.82zm0-243.56L308.15 244.28c-11.91 12.12-31.45 12.28-43.56.37-12.11-11.91-12.28-31.45-.37-43.56L401.77 61.81H309.7c-17.06 0-30.9-13.85-30.9-30.91 0-17.05 13.84-30.9 30.9-30.9h168.4C495.15 0 509 13.85 509 30.9v165.04c0 17.06-13.85 30.9-30.9 30.9-17.06 0-30.91-13.84-30.91-30.9v-92.47z'
// 							/>
// 						</svg>
// 					</a>
// 				</div>
// 				<img
// 					className='projects__img--pic'
// 					src={projectImage1}
// 					alt='project1'
// 				/>
// 			</div>
// 		</div>
// 	);
// }

// function ProjectsThree() {
// 	return (
// 		<div className='projects'>
// 			<div className='projects__img'>
// 				<img
// 					className='projects__img--pic'
// 					src={projectImage2}
// 					alt='project1'
// 				/>

// 				<div className='projects--used'>
// 					<h3 className='projects__title--name projects__title--name-one projects__title--name-one-left '>
// 						2048
// 					</h3>
// 					<div className='projects__title--used projects__title--used-one projects__title--used-one-left'>
// 						<ul>
// 							<li>JavaScript</li>
// 							<li>HTML</li>
// 							<li>SASS</li>
// 						</ul>
// 					</div>
// 				</div>
// 				<div className='projects--description--left projects--description-one projects--description-one-left'>
// 					<p>
// 						2048 - great game made in Vanilla Javascript ES6+ and SASS
// 						preprocessor.
// 					</p>
// 					<a
// 						href='https://seba2048.netlify.app/'
// 						target='_blank'
// 						rel='noreferrer'
// 					>
// 						<svg
// 							className='link'
// 							xmlns='http://www.w3.org/2000/svg'
// 							shape-rendering='geometricPrecision'
// 							text-rendering='geometricPrecision'
// 							image-rendering='optimizeQuality'
// 							fill-rule='evenodd'
// 							clip-rule='evenodd'
// 							viewBox='0 0 509 511.54'
// 						>
// 							<path
// 								fill-rule='nonzero'
// 								d='M447.19 347.03c0-17.06 13.85-30.91 30.91-30.91 17.05 0 30.9 13.85 30.9 30.91v87.82c0 21.08-8.63 40.29-22.51 54.18-13.88 13.88-33.09 22.51-54.18 22.51H76.69c-21.09 0-40.3-8.63-54.18-22.51C8.63 475.14 0 455.93 0 434.85V76.69c0-21.09 8.63-40.3 22.51-54.18C36.39 8.63 55.6 0 76.69 0h86.98c17.06 0 30.9 13.85 30.9 30.9 0 17.06-13.84 30.91-30.9 30.91H76.69c-4.07 0-7.82 1.69-10.51 4.37-2.68 2.69-4.37 6.44-4.37 10.51v358.16c0 4.06 1.69 7.82 4.37 10.5 2.69 2.68 6.44 4.38 10.51 4.38h355.62c4.07 0 7.82-1.7 10.51-4.38 2.68-2.68 4.37-6.44 4.37-10.5v-87.82zm0-243.56L308.15 244.28c-11.91 12.12-31.45 12.28-43.56.37-12.11-11.91-12.28-31.45-.37-43.56L401.77 61.81H309.7c-17.06 0-30.9-13.85-30.9-30.91 0-17.05 13.84-30.9 30.9-30.9h168.4C495.15 0 509 13.85 509 30.9v165.04c0 17.06-13.85 30.9-30.9 30.9-17.06 0-30.91-13.84-30.91-30.9v-92.47z'
// 							/>
// 						</svg>
// 					</a>
// 				</div>
// 			</div>
// 		</div>
// 	);
// }
export default App;
